import { SalesItemBookingCategoryType } from '@navio/nsdk';
import { NoddiIconName } from 'noddi-ui-common';

type Variant = {
  backgroundImage: string;
  iconName: NoddiIconName;
};

export const bookingCategoryVariants = (isMobile: boolean): Record<SalesItemBookingCategoryType, Variant> => ({
  [SalesItemBookingCategoryType.STONE_CHIP_REPAIR]: {
    backgroundImage: `/assets/svgs/booking/serviceCards/${isMobile ? 'mobile' : 'desktop'}/car_care.svg`,
    iconName: 'Wrench'
  },
  [SalesItemBookingCategoryType.WASH_SERVICES]: {
    backgroundImage: `/assets/svgs/booking/serviceCards/${isMobile ? 'mobile' : 'desktop'}/washing_package.svg`,
    iconName: 'Droplet'
  },
  [SalesItemBookingCategoryType.WHEEL_SERVICES]: {
    backgroundImage: `/assets/svgs/booking/serviceCards/${isMobile ? 'mobile' : 'desktop'}/wheel_service.svg`,
    iconName: 'WheelAngle'
  }
});
